import {IWorkersListItem, WorkersListItemResponseType} from "@/entity/workers/workers.types";
import {IStatus} from "@/entity/status/status.types";
import {IPosition} from "@/entity/position/position.types";
import {ICms_Category} from "@/entity/staff/staff.types";
import {IStaffScheduleListItem}  from "@/entity/staff/schedule.types"

export default class WorkerDetail implements IWorkersListItem {
    id: number;
    birth_date: string;
    cosmetolog_category_id: number;
    created_at: string;
    description: string;
    employment_date: string;
    last_name: string;
    middle_name: string | null;
    position_name: string | null;
    category_name: string | null;
    status_name: string | null;
    name: string;
    phone: string;
    position_id: number;
    salon_id: number;
    status: IStatus;
    position: IPosition;
    category: ICms_Category;
    updated_at: string;
    salary_schema_id: number;
    fio: string;
    cosmetolog_category:any;
    schedule:Array<IStaffScheduleListItem>;

    constructor(data: IWorkersListItem) {
        this.id = data.id;
        this.salon_id = data.salon_id;
        this.phone = data.phone;
        this.name = data.name;
        this.last_name = data.last_name;
        this.middle_name = data.middle_name;
        this.position_name = data.position_name;
        this.category_name = data.category_name;
        this.status_name = data.status_name;
        this.status = data.status;
        this.position = data.position;
        this.category = data.category;
        this.position_id = data.position_id;
        this.salary_schema_id = data.salary_schema_id;
        this.created_at = data.created_at;
        this.updated_at = data.updated_at;
        this.birth_date = data.birth_date;
        this.cosmetolog_category_id = data.cosmetolog_category_id;
        this.description = data.description;
        this.employment_date = data.employment_date;
        this.fio = data.last_name + ' ' + data.name + ' ' + data.middle_name;
        this.schedule = [];
        this.cosmetolog_category = null;
    }
}
